/*
 * Copyright (C) Luna Srl - All Rights Reserved
 *
 * @project    bfree-frontend.nosync
 * @file       CollaboratorIconImage.tsx
 * @author     Christian Ascone
 * @date       10/14/19 6:54 PM
 */

import React from 'react';
import {Image} from "react-native";

export function CollaboratorIconImage(props) {
    return (
        <Image
            {...props}
            style={[props.style]}
            source={
                require('../../../assets/images/collaborator_icon.png')
            }
        />
    );
}